import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import api from 'services/api';

import { RootState } from 'store';
import { addSpeakers, getSpeaker } from 'store/spearkeSlice';

type PeopleType = {
  videoHashId: string;
  currentShot: number;
  shots: any;
};

function PeopleList({ videoHashId, shots, currentShot }: PeopleType) {
  const speakerSlice = useSelector((state: RootState) => state.speakers);
  const [members, setMembers] = useState<any[]>([]);
  const dispatch = useDispatch();

  const videoShotId = useMemo(() => {
    if (!shots) return null;
    const idx = shots[currentShot]?.shot_hash_id;
    return idx;
  }, [currentShot, shots]);

  useEffect(() => {
    const members = getSpeaker(speakerSlice, videoShotId);
    const fetchPeople = async () => {
      if (!videoShotId) return;
      const response = await api.get(`/api/videos/${videoHashId}/shots/${videoShotId}/speakers/`);
      setMembers(response?.data);
      dispatch(addSpeakers({ shotId: videoShotId, speakerData: response.data }));
    };

    if (!members) {
      fetchPeople();
    } else {
      setMembers(members);
    }
  }, [videoShotId]);

  const capitalizeNames = (name: string) => {
    if (!name) return '';
    return name
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const peopleList = () => {
    if (members && members.length > 0) {
      return members
        .map((person: any, index: number) =>
          person?.name
            ? index === members.length - 1
              ? capitalizeNames(person.name)
              : capitalizeNames(person.name) + ', '
            : ''
        )
        .join('');
    }
    return '';
  };

  return (
    <>
      <p className="pt-4">People</p>
      <span>{peopleList()}</span>
    </>
  );
}

export default PeopleList;
